import { styled } from "@patientmpower/spiro";

export const LeftPanelUserSettingsContainer = styled("aside", {
  display: "none",

  "@sm": {
    display: "block",

    zIndex: 1200,

    backgroundColor: "$white",

    position: "fixed",
    top: 62,

    overflow: "hidden",

    width: 0,
    height: "100%",
    border: 0,
    paddingTop: "30px",
    paddingLeft: "0px",
    paddingRight: "0px",

    transition: "ease 500ms",
  },

  variants: {
    isOpen: {
      true: {
        "@sm": {
          width: "100%",

          paddingLeft: "60px",
          paddingRight: "60px",
        },
      },
    },
  },
});

export const UserSettingOption = styled("button", {
  fontFamily: "$openSans",
  fontSize: "$text-lg",
  fontWeight: "400",
  color: "$black",

  backgroundColor: "transparent",
  border: "unset",

  width: "100%",

  textAlign: "left",
});
